// extracted by mini-css-extract-plugin
module.exports = {"float-btn-wrap":"ge","floatBtnWrap":"ge","float-btn-snapping":"gf","floatBtnSnapping":"gf","float-btn-close":"gg","floatBtnClose":"gg"};